export default __webpack_public_path__ + "static/media/paused.84418d6d.svg";